import { Injectable } from '@angular/core';
import { AuthenticationService } from './authenticationService';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RouteNavigationService {
    currentRoute;
    prevRoute;
    navigatedRoutes = [];
    public exitOnNextBackPress = false;
    public childRoutes = ["/payadvance", "/viewstatement", "/account/changepin"];
    constructor(
        private nav: NavController,
        private router: Router,
    ) {
        this.init();
    }

    init() {
        this.currentRoute = undefined;
        this.prevRoute = "/invoices"; // /home
        this.navigatedRoutes = [];
        this.exitOnNextBackPress = false;
    }

    push(route) {
        if (this.navigatedRoutes.length > 0) {
            this.prevRoute = this.navigatedRoutes[this.navigatedRoutes.length - 1];
        }
        this.currentRoute = route;
        this.navigatedRoutes.push(this.currentRoute);
    }

    pop() {
        return this.navigatedRoutes.pop();
    }

    clear() {
        this.init();
    }

    setExitToTrue() {
        this.exitOnNextBackPress = true;
    }

    navigateRoot(routeUrl, params = {}) {
        this.push(routeUrl);
        this.nav.navigateRoot(routeUrl, params);
        //this.router.navigateByUrl(routeUrl, params);
    }

    back() {
        //this.nav.back();
    }

    getCurrentRoute() {
        if (!this.currentRoute) {
            this.currentRoute = '';//this.route.path;
        }
        return this.currentRoute;
    }

    navigateForward(url) {
        this.push(url);
        //this.nav.navigateRoot(url, {});
        this.router.navigateByUrl(url);
    }

    navigateToAppHome(params: any = {}) {
        this.navigateRoot('/invoices', params) //  /home
    }

    navigateToLoginPage(queryParams = {}) {
        this.navigateRoot('/signin', queryParams);
    }
}